import axios from "axios";
import { authHeaderJson } from "./auth-header.service";

const getPagedUsers = (pageNumber) => {
  return axios.post(`/api/client/get-paged-users`, { pageNumber: pageNumber, pageSize: 2 }, { headers: authHeaderJson() } );
};

const getAllUsers = (clientId) => {
  return axios.post(`/api/client/get-users?clientId=${(clientId ===null)? 0 : clientId}`, null, { headers: authHeaderJson() } );
};

const getAllProducts = (clientId) => {
  return axios.post(`/api/client/get-products?clientId=${(clientId ===null)? 0 : clientId}`, null, { headers: authHeaderJson() } );
};

const getPagedClients = (pageNumber, pageSize, filters, orderField, orderAsc) => {
  return axios.post(`/api/client/get-all`, {
    pageNumber: pageNumber,
    pageSize: pageSize,
    filters: filters,
    orderField: orderField,
    orderAsc: orderAsc
  }, { headers: authHeaderJson() } );
};

const assingUsers = async (clientId, userList) => {
  return await axios.post(`/api/client/assing-users`, {userList: userList, clientId: clientId} , { headers: authHeaderJson() } )
};

const unAssingUsers = async (clientId, userList) => {
  return await axios.post(`/api/client/unassing-users`, {userList: userList, clientId: clientId}, { headers: authHeaderJson() } )
};

const getAllClients = () => {
  return axios.post(`/api/client/get-all-nopaged`, null, { headers: authHeaderJson() } );
};



const getAllContracts = (clientId) => {
  return axios.post(`/api/client/get-all-contracts?clientId=${clientId}`, null, { headers: authHeaderJson() } );
};

const getAllCompanies = (clientId) => {
  return axios.post(`/api/client/get-all-companies?clientId=${clientId}`, null, { headers: authHeaderJson() } );
};

const getAllBusinessUnitsTree = (clientId) => {
  return axios.post(`/api/client/orgestructureorder?clientId=${clientId}`, null, { headers: authHeaderJson() } );
};

const getAllBusinessUnits = (clientId) => {
  return axios.post(`/api/client/get-all-businessUnits?clientId=${clientId}`, null, { headers: authHeaderJson() } );
};

const getAllJobPositions = (clientId) => {
  return axios.post(`/api/client/get-all-jobs?clientId=${clientId}`, null, { headers: authHeaderJson() } );
};

const getJobPosition = (clientId, jobNemo) => {
  return axios.post(`/api/client/get-job-by-id?clientId=${clientId}&jobNemo=${jobNemo}`, null, { headers: authHeaderJson() } );
};

const getAllCompaniesByUserId = (userId) => {
  return axios.post(`/api/client/get-all-companies-by-user-id?userId=${userId}`, null, { headers: authHeaderJson() } );
};

const getAllAreasByUserId = (userId) => {
  return axios.post(`/api/client/get-all-areas-by-user-id?userId=${userId}`, null, { headers: authHeaderJson() } );
};

const getAllJobsByUserId = (userId) => {
  return axios.post(`/api/client/get-all-jobs-by-user-id?userId=${userId}`, null, { headers: authHeaderJson() } );
};

const addPermission = (objPermissions) => {

  const data = JSON.stringify(objPermissions);
  const config = {
    method: 'post',
    url: `/api/client/add-permission`,
    headers: authHeaderJson(),
    data : data
  };
  
  return axios(config);
};

const removePermission = (userRoleId, clientId) => {

  const data = JSON.stringify({userRoleId: userRoleId , clientId: clientId});
  const config = {
    method: 'post',
    url:  `/api/client/remove-permission`,
    headers: authHeaderJson(),
    data : data
  };

  return axios(config);
};

const getAllPermissions = (clientId, pageNumber, pageSize, filters, orderField, orderAsc) => {
  const data = JSON.stringify({
    pageNumber: pageNumber,
    pageSize: pageSize,
    filters: filters,
    orderField: orderField,
    orderAsc: orderAsc
  });

  return axios.post(`/api/client/get-all-permissions?clientId=${clientId}` , data, { headers: authHeaderJson() } );
};

const getAllPermissionsByUser = (userId, clientId, pageNumber, pageSize, filters, orderField, orderAsc) => {
  const data = JSON.stringify({
    pageNumber: pageNumber,
    pageSize: pageSize,
    filters: filters,
    orderField: orderField,
    orderAsc: orderAsc
  });

  return axios.post(`/api/client/get-all-permissions-by-user?userId=${userId}&clientId=${clientId}` , data, { headers: authHeaderJson() } );
};

const getAllPermissionsExportExcel = (clientId, listField, _data) => {
  const data = JSON.stringify({
    pageNumber: 1,
    pageSize: 0,
    filters: _data.filters,
    orderField: _data.orderField,
    orderAsc: _data.orderAsc
  });

  return axios.post(`/api/client/get-all-permissions-export-excel?clientId=${clientId}&strListField=${listField}` , data, { headers: authHeaderJson() } );
};
const getUserCountAuthRoles = (clientId, productId, userName) => {
    if (productId !== null && clientId !== null) {
      return axios.post(`/api/client/get-user-count-auth-roles?clientId=${clientId}&productId=${productId}`, null, { headers: authHeaderJson() } );
    }
    if (clientId !== null) {
      return axios.post(`/api/client/get-user-count-auth-roles?clientId=${clientId}`, null, { headers: authHeaderJson() } );
    }
    else {
      return axios.post(`/api/client/get-user-count-auth-roles`, null, { headers: authHeaderJson() } );
    }
};
const getUserCountSg3Roles = (clientId, productId, userName) => {
    return axios.post(`/api/client/get-user-count-auth-roles-by-userid?clientId=${clientId}&productId=${productId}&userName=${userName}`, null, { headers: authHeaderJson() } );
};

const getClient = (clientId) => {
  return axios.post(`/api/client/get?clientId=${clientId}`, null , { headers: authHeaderJson() } );
};

const editClient = (objClient) => {
  return axios.post("/api/client/edit", objClient, { headers: authHeaderJson() } 
  ).then((response) => {
    return response.data;
  });
};

const createClient = (objClient) => {
  return axios.post("/api/client/create", objClient, { headers: authHeaderJson() } 
  ).then((response) => {
    return response.data;
  });
};

const enableClient = (clientId) => {
  return axios.post(`/api/client/enable?client_id=${clientId}`, null, { headers: authHeaderJson() } );
};

const disableClient = (clientId) => {
  return axios.post(`/api/client/disable?client_id=${clientId}`, null, { headers: authHeaderJson() } );
};

const getContractAndUserCounts = (userName) => {
  const data = JSON.stringify(userName);
  const config = { method: 'post', url: `/api/client/get-count-of-contracts-and-users`, headers: authHeaderJson(), data : data };
  
  return axios(config);
};

const getProductSuscriptions = async (userName) => {
  const data = JSON.stringify(userName);
  const config = { method: 'post', url: `/api/client/get-product-suscriptions`, headers: authHeaderJson(), data : data };
  
  return await axios(config);
};

const removeProductSuscriptions = async (clientProduct) => {
  const data = JSON.stringify(clientProduct);
  const config = { method: 'post', url: `/api/client/remove-product-suscription`, headers: authHeaderJson(), data : data };
  
  return await axios(config);
};

const createProductSuscriptions = async (clientProduct) => {
  const data = JSON.stringify(clientProduct);
  const config = { method: 'post', url: `/api/client/create-product-suscription`, headers: authHeaderJson(), data : data };
  
  return await axios(config);
};

const activateProductSuscriptions = async (clientProduct) => {
  const data = JSON.stringify(clientProduct);
  const config = { method: 'post', url: `/api/client/activate-product-suscription`, headers: authHeaderJson(), data : data };
  
  return await axios(config);
};

const generateProductKeySuscriptions = async (clientProduct) => {
  const data = JSON.stringify(clientProduct);
  const config = { method: 'post', url: `/api/client/generate-product-key-suscription`, headers: authHeaderJson(), data : data };
  
  return await axios(config);
};


export default {
  getPagedUsers,
  getAllUsers,
  getPagedClients,
  getAllClients,
  getClient,
  editClient,
  createClient,
  assingUsers,
  unAssingUsers,
  getAllProducts,
  enableClient,
  disableClient,
  getContractAndUserCounts,
  getUserCountSg3Roles,
  getUserCountAuthRoles,
  getProductSuscriptions,
  removeProductSuscriptions,
  createProductSuscriptions,
  activateProductSuscriptions,
  generateProductKeySuscriptions,

  getAllCompanies,
  getAllBusinessUnits,
  getAllBusinessUnitsTree,
  getAllJobPositions,
  getJobPosition,
  getAllCompaniesByUserId,
  getAllAreasByUserId,
  getAllJobsByUserId,
  
  getAllPermissionsExportExcel,
  getAllContracts,
  getAllPermissions,
  getAllPermissionsByUser,
  addPermission,
  removePermission
};